import { render, staticRenderFns } from "./new.image-assets.page.vue?vue&type=template&id=8f5ad8fa&"
import script from "./new.image-assets.page.vue?vue&type=script&lang=js&"
export * from "./new.image-assets.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports